module.exports = "<hospital-booking-header></hospital-booking-header>\n<div class=\"container\" *ngIf=\"actions && actions.length > 0\">\n  <p [innerHTML]=\"'hospital_booking.execute_action.title' | translate\"></p>\n\n  <div>\n    <ng-container *ngFor=\"let action of actions\">\n      <button class=\"blue-button\" (click)=\"executeAction(action)\" [innerHTML]=\"('hospital_booking.execute_action.' + action) | translate\"></button><br>\n    </ng-container>\n  </div>\n</div>\n\n<hospital-booking-footer></hospital-booking-footer>"


//////////////////
// WEBPACK FOOTER
// ./ng2/hospital-booking/execute-action/execute-action.component.html
// module id = 773
// module chunks = 0